import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { CacheService } from '../cache';
import { ResourceService } from './resource';
import { Resource } from '../../models/resource';
import { CreateFlyerDto, Flyer, FlyerApiResponse, UpdateFlyerDto } from '../../models/flyer';

@Injectable({
  providedIn: 'root'
})
export class FlyerService extends ResourceService<Resource > {
  private readonly FREQUENT_FLYERS_BASE = 'frequent-flyers';

  constructor(
    protected http: HttpClient,
    protected cache: CacheService
  ) {
    super(http, cache, 'frequent-flyers');
  }
/**
   * Create Flyer - Return full API response (if you need message or full wrapper)
   */
  createFlyerFullResponse(data: CreateFlyerDto): Observable<FlyerApiResponse> {
    const url = this.FREQUENT_FLYERS_BASE;
    return this.http.post<FlyerApiResponse>(url, data).pipe(
      tap(() => this.cache.remove(this.FREQUENT_FLYERS_BASE))
    );
  }
  /**
   * Update Flyer - Return full API response
   */
  updateFlyerFullResponse(id: string, updates: UpdateFlyerDto): Observable<FlyerApiResponse> {
    const url = `${this.FREQUENT_FLYERS_BASE}/${id}`;
    return this.http.put<FlyerApiResponse>(url, updates).pipe(
      tap(() => this.cache.remove(this.FREQUENT_FLYERS_BASE))
    );
  }
  /**
   * Get Flyers by User - Return full API response
   */
  getFlyersByUserFullResponse(userId: string): Observable<FlyerApiResponse> {
    const url = `${this.FREQUENT_FLYERS_BASE}/user/${userId}`;
    return this.http.get<FlyerApiResponse>(url);
  }
/**
   * Delete Flyer - Return full API response (if needed)
   */
  deleteFlyerFullResponse(id: string): Observable<FlyerApiResponse> {
    const url = `${this.FREQUENT_FLYERS_BASE}/${id}`;
    return this.http.delete<FlyerApiResponse>(url).pipe(
      tap(() => this.cache.remove(this.FREQUENT_FLYERS_BASE))
    );
  }
}
